import React from "react";

export function Logo({ light = false, size = "md" }) {
  const dims = size === "lg" ? "h-12 w-12" : "h-9 w-9";
  const title = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div className={`relative flex items-center justify-center ${dims}`}>
        <svg viewBox="0 0 40 40" fill="none" className="h-full w-full">
          <defs>
            <linearGradient id="rlGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="hsl(var(--trust))" />
              <stop offset="100%" stopColor="hsl(var(--calm))" />
            </linearGradient>
          </defs>
          <path
            d="M20 2L35 10V22C35 30 28 37 20 38C12 37 5 30 5 22V10L20 2Z"
            fill="url(#rlGrad)"
          />
          <path
            d="M14 20L18 24L26 16"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={`font-display font-bold tracking-tight ${title} ${
            light ? "text-white" : "text-foreground"
          }`}
        >
          Recovery<span className="text-secondary"> Leaders</span>
        </span>
        <span
          className={`mt-1 text-[10px] font-semibold uppercase tracking-[0.25em] ${
            light ? "text-white/70" : "text-muted-foreground"
          }`}
        >
          Trusted Recovery
        </span>
      </div>
    </div>
  );
}

export default Logo;
